(ns frontend.view.entity-viewers.module-card
  (:require-macros [frontend.macros :refer [without-default-action-and-propagation]])
  (:require
   [reagent.core :as r]
   [potpuri.core :as p :refer [fn-> fn->> index-by deep-merge]]
   [frontend.utils :as fu]
   [common.localization :as loc]))

(defn view
  []
  (let [local-state (r/atom {:collapsed? true})]
    (fn [{:keys [module-id drag-atom on-drag-start! on-drag-end! on-drag-over! on-drag-leave!
                 class-name header header-tools body
                 toggle-collapse! collapsed? start-collapsed?
                 toggle-expanded! expanded? start-expanded? hide-drag-handle?]
          :as   args} & content]
      (let [;;if collapsed? and toggle-collapse! not received from params, fall back to local state:
            collapsed? (if (not start-collapsed?)
                         collapsed?
                         (:collapsed? @local-state))
            expanded? (if (not start-expanded?)
                        expanded?
                        (:expanded? @local-state))
            local-toggle-collapse! (r/partial swap! local-state assoc :collapsed?)
            local-toggle-expanded! (r/partial swap! local-state assoc :expanded?)
            toggle-collapse! (cond
                               (not start-collapsed?) toggle-collapse!
                               (not collapsed?) local-toggle-collapse!
                               :else (fn [c]
                                       (toggle-collapse! c) ;;prevent collapsing when adding new attachment/association
                                       (local-toggle-collapse! c)))
            toggle-expanded! (when toggle-expanded!
                               (fn [e]
                                 (toggle-expanded! e)
                                 (local-toggle-expanded! e)))]
        [:div
         {:class        (fu/cs "p-4 mb-2 bg-base-light border border-solid border-base-light-border-paler rounded transition"
                                (when (and module-id
                                           (= (:drag-id @drag-atom) module-id))
                                  "dragging")
                                (when collapsed? "collapsed")
                                class-name)
          :style         (if expanded?
                           {:position "relative"
                            :width    "calc(100vw - 20rem)"
                            :z-index  10
                            :overflow "auto"}
                           {:position "relative"})
          :on-drag-enter (fn [e]
                           (.preventDefault e))
          :on-drag-over  (fn [e]
                           (.preventDefault e)
                           (on-drag-over! module-id)
                           (aset e "dataTransfer" "effectAllowed" "move"))
          :on-drag-leave (fn [e]
                           (.preventDefault e)
                           (on-drag-leave! module-id))
          :on-drop       (fn [e]
                           (.preventDefault e)
                           (.stopPropagation e))}
         [:div 
          {:class "flex justify-between items-center font-bold cursor-pointer group"}
          [:div
           {:class "flex gap-2 items-center w-full"
            :on-click (fn []
                        (toggle-collapse! (not collapsed?)))}
           (when-not hide-drag-handle?
             [:i.fal.fa-grip-vertical
              {:class "invisible group-hover:visible"
               :draggable     true
               :on-drag-start (fn [e]
                                (aset e "dataTransfer" "effectAllowed" "move")
                                ;;drag data must be set for dragend to fire in firefox:
                                (.. e -dataTransfer (setData "text" "zapflow"))
                                (on-drag-start! module-id))
               :on-drag-end   (fn [me]
                                (.preventDefault me)
                                (.stopPropagation me)
                                (on-drag-end! module-id))
               :on-drop       (fn [e])
               :on-click      (without-default-action-and-propagation
                               ;;prevent collapse
                              )}])

           [:span
            {:class "flex items-center gap-2"}
            header
            (if collapsed?
              [:i.far.fa-chevron-right.text-xs]
              [:i.far.fa-chevron-down.text-xs])]
           (when (or header-tools (fn? toggle-expanded!))
             [:span
              {:class "flex items-center justify-end flex-1"
               :on-click (without-default-action-and-propagation
                          ;;prevent collapse
                         )}
              (when (fn? toggle-expanded!)
                [:span
                 {:on-click (fn [e]
                              (toggle-expanded! (not expanded?)))}
                 (if expanded?
                   (loc/tr :collapse)
                   (loc/tr :expand))
                 " "
                 (if expanded?
                   [:i.fal.fa-compress-arrows-alt]
                   [:i.fal.fa-expand-arrows-alt])])
              header-tools])]]

         [:div
          {:class-name (fu/cs "px-3"
                              (when collapsed? "h-0 overflow-hidden"))}
          (vec
           (concat ;;avoid react warnings when content is a list of multiple elements
            [:div
             {:class-name (fu/cs "*:flex *:flex-col *:gap-2"
                                 (when collapsed? "h-0 overflow-hidden"))}]
            content))]]))))
